import { keyframes, styled } from '@styles/stitches';

const fadeIn = keyframes({
  from: { opacity: 0 },
  to: { opacity: 1 },
});

const fadeOut = keyframes({
  from: { opacity: 1 },
  to: { opacity: 0 },
});

export const Overlay = styled('div', {
  position: 'absolute',
  top: 0,
  left: 0,
  width: 'calc(100% - 0px)',
  height: 'calc(100% - 0px)',
  zIndex: 1,

  '@media (prefers-reduced-motion: no-preference)': {
    animation: `${fadeIn} 200ms ease-out`,
    willChange: 'transform',

    '&[data-state="closed"]': {
      animation: `${fadeOut} 100ms ease-out`,
    },
  },
});

export const Checkmark = styled('div', {
  position: 'absolute',
  bottom: 4,
  right: 4,
  zIndex: 1,

  i: {
    display: 'block',
    fontSize: 18,
    fontWeight: 700,
    color: '$primaryFill',
  },

  '@media (prefers-reduced-motion: no-preference)': {
    animation: `${fadeIn} 200ms ease-out`,
    willChange: 'transform',

    '&[data-state="closed"]': {
      animation: `${fadeOut} 100ms ease-out`,
    },
  },
});

export const Content = styled('div', {
  display: 'block',
  position: 'relative',

  variants: {
    selected: {
      true: {
        [`& ${Overlay}`]: {
          background: 'linear-gradient(0deg, rgba(0,0,0,1) 0%, rgba(0,0,0,0.1) 60%)', // 30%
        },
      },
    },
  },
});
